import { createPinia, defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { ViewType } from '@components-molecules/map/map-constants';

export const usePageBrandStore = defineStore('pageBrand', () => {
  const paginatedPageSpaces = ref(window.PAGINATED_PAGE_SPACES ?? []);
  const pagination = ref(window.PAGINATION);
  const selectedPageSpace = ref(null);
  const mobileView = ref(ViewType.LIST);

  const setSelectedPageSpace = (pageSpace) => {
    if (!pageSpace) {
      document.getElementById(`page-space-${selectedPageSpace.value.id}`)?.classList.remove('space-card-hover');
      selectedPageSpace.value = pageSpace;

      return;
    }

    selectedPageSpace.value = pageSpace;

    document.getElementById(`page-space-${pageSpace.id}`)?.classList.add('space-card-hover');
  };

  const setPaginatedPageSpaces = (pageSpaces) => {
    paginatedPageSpaces.value = pageSpaces;
  };

  const primaryPageSpaceMarkers = computed(
    () => paginatedPageSpaces.value.slice((pagination.value.page - 1) * pagination.value.offset, pagination.value.page * pagination.value.offset),
  );

  const secondaryPageSpaceMarkers = computed(() => {
    const primaryMarkersId = primaryPageSpaceMarkers.value.map((pageSpace) => pageSpace.id);

    return paginatedPageSpaces.value.filter((marker) => !primaryMarkersId.includes(marker.id));
  });

  const setNewPage = (newPage) => {
    pagination.value.page = newPage;
  };

  const setMobileView = (newView) => {
    mobileView.value = newView;

    const listContent = document.querySelector('.brand-details');
    if (listContent) {
      // eslint-disable-next-line no-unused-expressions
      newView === ViewType.MAP ? listContent.classList.add('show-mobile-map') : listContent.classList.remove('show-mobile-map');
    }
  };

  return {
    paginatedPageSpaces,
    selectedPageSpace,
    primaryPageSpaceMarkers,
    secondaryPageSpaceMarkers,
    pagination,
    mobileView,
    setPaginatedPageSpaces,
    setSelectedPageSpace,
    setMobileView,
    setNewPage,
  };
});

export const piniaPageBrand = createPinia();
